










































































import uuid from 'uuid/v1';
import Vue, { PropType } from 'vue';
import { UUID } from '@/types';
import FieldBase from '@/components/field/Base.vue';
import ShowGuide from '@/components/ShowGuide.vue';
import { GridColumn, GridTable } from '@/components/grid';
import { currencies } from '@/constants';
import { Price, PriceType } from '@/services/price/types';

const formattedCurrencies = Object
  .keys(currencies)
  .reduce((p, key) => {
    const data = (currencies as any)[key];
    p[key] = `${data.name} (${data.symbol_native})`;
    return p;
  }, {} as any);

export default Vue.extend({
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<PriceType>,
      required: true,
    },
    typeId: {
      type: String as PropType<UUID>,
    },
    value: {
      type: Array as PropType<Price[]>,
      default: () => [],
    },
  },
  data: () => ({
    currencyParams: {
      title: 'Currency',
      type: 'dropdown',
      largeTitle: true,
      values: formattedCurrencies,
      display: (key: string) => (
        key && `${key} (${(currencies as any)[key].symbol_native})`
      ),
    },
  }),
  computed: {
    localValue: {
      get(): Price[] {
        return this.value;
      },
      set(prices: Price[]) {
        this.$emit('input', prices.map(
          (price, index: number) => ({
            ...price,
            // re index price on reorder
            index,

            // update types as we assume
            // that it doesn't get fetched on gql query
            type: this.type,
            type_id: this.typeId,
          }),
        ));
      },
    },
  },
  methods: {
    shape() {
      const total = this.localValue.length;
      const previousCurrency = total
        ? this.localValue[total - 1].currency
        : undefined;

      return {
        id: uuid(),
        currency: previousCurrency,
      };
    },
  },
  components: {
    FieldBase,
    GridColumn,
    GridTable,
    ShowGuide,
  },
});
